import * as idEndpoints from './id';
import { id, root } from './subjects';

export const subjects = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
